import React, { useRef, useEffect, useState } from "react";
import ReactDOM from 'react-dom';
import './Modal.css'; // Assuming you have some basic styles for the modal
import { ReactComponent as Close } from '../../svg/close.svg';

import { ReactComponent as Edit } from '../../svg/edit.svg';



function ModalSortDescription({ isOpen, changeLvl, spell, dropdown, setOpen, setModif,setIsModalNewOpen}) {

  const [refChild, setRefChild] = useState(null);
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target) && event.target.id != spell.nom) {
          console.log(event.target.id)
            handleClose(false)
          
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, spell]);
  }
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  const handleClose = (bool) => {
    setOpen(false)
  }
  if (!isOpen) return null;


  const handleLvlChange = (value, nom) => {
    if (value == "+") {
      setIsModalNewOpen(true);
    } else {
      changeLvl(value, nom);
    };
  }
  const handleModif = () => {
    setModif(true)
    setOpen(false)
  };
  return (
    <div className="modal-overlay" >
      <div className='modal_flex' ref={wrapperRef}>
        <div className="close" onClick={() => handleClose(false)}>
          <Close></Close>
        </div>
        <div className="edit" onClick={() => handleModif()}>
          <Edit></Edit>
        </div>
        <div className="modal_title">{spell.nom}</div>

        <div className="modal_bloc"><strong>Description : </strong> {spell.description}</div>
        <hr className="modal_separator" />
        <div className="modal_bloc"><strong>Effet : </strong>{spell.effet}</div>
        <hr className="modal_separator" />
        <div className="modal_bloc flex space_around">
          <div>{spell.cout} Energie</div>
          <div className="modal_lvlsort">
            <span>Niveau </span>
            <select onChange={(e) => handleLvlChange(e.target.value, spell?.nom)}>
              {Object.keys(dropdown).map(niv => (
                <option key={niv} value={niv}>
                  {niv}
                </option>
              ))}
              <option value="+">+</option>
            </select>
          </div>

        </div>
      </div>

    </div>
  );
}

export default ModalSortDescription;
